<div class="container">

  <br/>
  <br/>

  <h1>Privacy Policy</h1>
  <br/>

  <p>
    The Croissant website (the “Site”) is operated by Croissant Inc. Croissant
    is committed to respecting and protecting your privacy. To that end, we have
    prepared this privacy policy (“Privacy Policy”) to describe our information
    gathering and dissemination practices and our data protection practices for
    the Site; The terms “Croissant,” “we,” “us,” and “our” refer to Croissant
    Inc. and its subsidiaries and affiliates. The terms “you,” “your,” and
    “yours” refer to the user/customer utilizing the Site. This Privacy Policy
    is governed by our Terms of Use.
  </p>

  <h3>CHILDREN</h3>

  <p>
    The Site is not intended for or directed to persons under the age of 13, and
    we will not knowingly collect information from such persons. Any person who
    provides information to us through registration or in any other manner on
    the Site represents to Croissant that they are 13 years of age or older. If
    we learn that a child under 13 has submitted personal information to us, we
    will attempt to delete the information as soon as possible.
  </p>

  <h3>COLLECTION OF INFORMATION</h3>

  <p>
    “Personally Identifiable Information” means any information which can be
    used to identify an individual, and may include, but is not limited to,
    name, email address, postal or other physical address, title, or occupation.
    We collect the following Personally Identifiable Information from you when
    you register for the Site: name and email address. To participate in certain
    activities and to obtain certain services or documents offered on the Site,
    you may be asked to provide additional Personally Identifiable Information
    such as phone number, billing address and credit card information. We
    endeavor to limit our requests for Personally Identifiable Information to
    information we believe is reasonably necessary to achieve our purposes as
    described in the “Information Use” section below. Any Personally
    Identifiable Information received in communication or in material you
    transmit to the Site by electronic mail or otherwise are and will be treated
    in accordance with this Privacy Policy.
  </p>

  <h3>INFORMATION USE</h3>

  <p>
    Croissant uses Personally Identifiable Information for several general
    purposes:
  </p>

  <p>
    to provide you with service information, and news,<br/>
    to support the services offered on the Site,<br/>
    to contact you for feedback about our services,<br/>
    to conduct research about Croissant’s customer base or services,<br/>
    to fulfill your reservation and purchase requests,<br/>
    to process your payments including credit checks and collection,<br/>
    to notify you of technical updates or changes in policy, or<br/>
    to contact you for our own marketing and promotional purposes.<br/>
    We may use non-Personally Identifiable Information such as demographic data
    to analyze and develop our marketing strategy and further improve the Site
    and our services.
  </p>

  <h3>INFORMATION SHARING AND DISCLOSURE</h3>

  <p>
    We will not sell or rent your Personally Identifiable Information to third
    parties except as described in this Privacy Policy. We may disclose your
    Personally Identifiable Information to other companies or people under any
    of the following circumstances:
  </p>

  <p>
    to any applicable venue, community manager, or other service provider for
    each space or event that you check in to on the Site.<br/>
    if sharing the information is reasonably necessary to provide a service that
    you have requested.<br/>
    to keep you up to date on the latest product announcements, software
    updates, special offers, or other information we think you would like to
    know more about either from us or from our business partners (unless you
    have opted out of these types of communications).<br/>
    if we believe in good faith that we are required to do so by law, in
    connection with litigation, to prevent a crime, or to protect personal
    property, the public, or the Site.<br/>
    in connection with a sale or merger with another entity or if Croissant
    should ever file for bankruptcy or have its assets sold to another enity.<br/>
    when we otherwise have your consent to share the information.<br/>
    Croissant may also share non-Personally Identifiable Information with third
    parties (e.g. aggregate or demographic data).
  </p>

  <h3>CHOICE</h3>

  <p>
    We will give you the opportunity to “opt out” of receiving direct marketing
    or market research information. This means we assume you have given us your
    consent to collect and use your information in accordance with this Privacy
    Policy unless you take affirmative action to indicate that you do not
    consent, for instance by clicking or checking the appropriate option or box
    at the point of collection.
  </p>

  <h3>ACCESS</h3>

  <p>
    You may correct, amend, or delete your Personally Identifiable Information
    by editing your profile on the Site or emailing us at
    support&#64;getcroissant.com.
  </p>

  <h3>SECURITY</h3>

  <p>
    We are committed to protecting Personally Identifiable Information from
    loss, misuse, disclosure, alteration, unauthorized access, and destruction.
    Croissant takes reasonable precautions to safeguard the confidentiality of
    Personally Identifiable Information. We protect the security of your
    Personally Identifiable Information during transmission to us by using
    Secure Sockets Layer (SSL) software, which encrypts the information you
    input.
  </p>

  <h3>THIRD PARTY SITES</h3>

  <p>
    The Site may contain links to other sites. Croissant is not responsible for
    the privacy practices of such other sites. We encourage our users to be
    aware when leaving the Site to read the privacy statements of each site that
    collects Personally Identifiable Information.
  </p>

  <h3>COOKIES</h3>

  <p>
    We use third-party advertising companies to serve advertisements on our
    behalf. These companies may use a cookie or an action tag, also known as a
    Web Beacon or a 1 pixel .gif file, to tailor the advertisements you see on
    this Website and other sites, to track your response to their advertisement
    and to measure the effectiveness of their advertising or to award incentives
    or points to their members who respond to their advertisements. The cookies,
    action tags or similar files do not contain any Personal Information.
  </p>

  <p>
    You can learn more about targeted advertising, its benefits and your choices
    by going to http://www.aboutads.info/consumers/. The targeted advertising
    companies we work with are members of the Network Advertising Initiative.
    The NAI allows you to limit targeted advertising from its members by using
    an opt-out tool available on the NAI website at networkadvertising.org.
  </p>

  <h3>YOUR CONSENT TO THIS PRIVACY POLICY</h3>

  <p>
    By using this Site, you agree to this Privacy Policy. We may occasionally
    update this Privacy Policy. The date of the most recent update of this
    document will always be displayed at the beginning of this page. If we
    change our Privacy Policy, we will post those changes on getcroissant.com.
    If we decide to use Personally Identifiable Information in a manner
    different from that stated at the time it was collected, we will notify
    users via email (if an email address has been provided) or display a notice
    on getcroissant.com. We encourage you to periodically review this Privacy
    Policy to stay informed about how we are protecting the Personally
    Identifiable Information we collect. Your continued use of this Site
    constitutes your agreement to this Privacy Policy and any updates.
  </p>

  <h3>CONTACTING CROISSANT</h3>

  <p>
    If you have any questions, comments, or concerns about this Privacy Policy,
    please contact us at:
  </p>

  <p>
    Croissant Inc.<br/>
    One World Trade Center, Suite 8500<br/>
    New York, NY 10007<br/>
    Email: support&#64;getcroissant.com
  </p>

  <br/>
</div>
